const $ = jQuery.noConflict();

$.fn.extend({
  locrating: function () {
    self.init(this.selector);
  },
});

var self = (module.exports = {
  init: function (el) {
    $(el).each(function () {
      var load = $(this).data("load");

      if (typeof load !== "undefined" && load == true) {
        self.service.init(this);
      }
    });
  },

  service: {
    init: function (el) {
      var iframe = $(el).find("iframe");
      var frame = {
        id: $(iframe).attr("id"),
        lat: $(iframe).data("lat"),
        lng: $(iframe).data("lng"),
        icon: $(iframe).data("ico"),
        'mapstyle': $(iframe).data('mapstyle'),
        'menucolor': $(iframe).data('menucolor'),
        'menubackcolor': $(iframe).data('menubackcolor'),
        'menuselectcolor': $(iframe).data('menuselectcolor'),
        'menuselectbackcolor': $(iframe).data('menuselectbackcolor'),
        'menuallcaps': $(iframe).data('menuallcaps'),
        'menuallcaps': $(iframe).data('menuallcaps'),
        'showtransporttab': $(iframe).data('showtransporttab')
      };

      switch ($(iframe).data("type")) {
        case "schools-map":
          frame.type = "schools";
          // frame.maxschools= '5';
          break;
        case "stations-map":
          frame.type = "localinfo";
          frame.showstations = "only";
          frame.zoom = "12";
          break;
        case "stations-list":
          frame.type = "stations";
          // frame.maxstations= '5';
          break;
        case "localinfo-map":
          frame.type = "localinfo";
          break;
        case "all-in-one":
          frame.type = "all";
          frame.menuallcaps = "true";
          break;
        case "localinfo-list":
          // frame.type = '';
          break;
        default:
          break;
      }
 
      try {
        setLocratingIFrameProperties(frame);
        frame;
      } catch (err) {}
    },
  },
});
